<template>
  <div>
    <div>
      <v-card
        style="background-color: transparent; border-radius: 15px"
        elevation="1"
      >
        <v-card-text>
          <v-container>
            <v-row
              dense
              class="mt-9"
              v-if="loading"
              alig="center"
              justify="center"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
            <div v-else>
              <v-row dense>
                <v-row dense class="mt-9">
                  <v-row dense>
                    <v-col>
                      <v-card
                        elevation="0"
                        style="
                          border-radius: 10px;
                          position: relative;
                          overflow: visible;
                          background-color: transparent;
                        "
                      >
                        <v-card-text style="background-color: transparent">
                          <v-row dense style="padding: 2vh">
                            <v-col cols="12" md="12" lg="12">
                              <div
                                class="d-flex align-start justify-start flex-column"
                              >
                                <span style="font-size: 18px">Curso</span>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-card
                        elevation="0"
                        style="
                          border-radius: 10px;
                          max-width: 100vw;
                          background-color: transparent;
                        "
                      >
                        <v-card-text>
                          <v-row dense style="padding: 2vh">
                            <v-col md="3" lg="3" sm="3" xs="3">
                              <div
                                class="d-flex align-start justify-center flex-column"
                              >
                                <strong class="header">Meus Módulos</strong>
                                <span class="regular mt-4"
                                  >Check your daily tasks and schedules</span
                                >
                              </div>
                            </v-col>
                            <v-col md="2">
                              <v-img
                                contain
                                src="@/assets/images/connect/customer/modules.svg"
                                max-width="15vw"
                                max-heigth="15vh"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-row>
              </v-row>
              <v-container
                class="mt-10 pt-10"
                v-if="continueWathing.length > 0"
              >
                <v-row dense>
                  <span style="font-size: 24px">Continue assistindo</span>
                </v-row>
                <v-row dense class="mt-10"></v-row>
                <v-row dense>
                  <v-col v-for="(item, index) in continueWathing" :key="index">
                    <LessonCard :item="item" @toLeason="goToLesson" />
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-container>
          <v-container v-if="leassons.length > 0 && !loading">
            <v-row dense class="d-flx align-start justify-start">
              <span style="font-size: 24px">Aulas</span>
            </v-row>
            <v-row
              dense
              style="margin-top: 5vh"
              v-if="leassons.length > 0 && !loading"
            >
              <v-col
                v-for="(item, index) in leassons"
                :key="index"
                class="d-flex align-center justify-center pa-1"
                cols="12"
                md="4"
              >
                <CourseCard
                  :moduleColor="'primary'"
                  :item="item"
                  @toCourse="goToCourse"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="extra.length > 0 && !loading">
            <v-row dense class="d-flx align-start justify-start">
              <span style="font-size: 24px">Módulos extras - em breve</span>
            </v-row>
          </v-container>
          <v-container
            v-if="!loading && extra.length === 0 && leassons.length === 0"
          >
            <v-row dense class="d-flx align-center justify-center">
              <span style="font-size: 24px">Nenhum conteúdo disponível 😢</span>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import LessonCard from "@/components/connect/leassons/LessonCard.vue";
import CourseCard from "@/components/connect/course/CourseCard.vue";
import pitchCustomerApi from "@/shared/pitchCustomerApi";

export default {
  name: "CourseArea",
  components: {
    LessonCard,
    CourseCard,
  },
  async created() {
    this.loading = true;

    await pitchCustomerApi
      .getCourse()
      .then((response) => {
        this.loading = false;

        this.course = response.data.module;
        this.leassons = response.data.module.classes;

        this.$root.$emit("display-alert", {
          text: `Seja bem-vindo ao módulo ${this.course.title}`,
          type: 0,
          timeout: 1000,
        });
      })
      .catch((err) => {
        if (err.response.status === 400) {
          this.$root.$emit("display-alert", {
            text: `Primeiramente vamos dar match com o professor 😉`,
            type: 0,
            timeout: 1500,
          });

          this.$router.push({
            name: "Turmas",
          });
        } else {
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro ao carregar seu módulo",
            type: 2,
            timeout: 1000,
          });

          this.leassons = [];
          this.loading = false;
        }
      });
  },
  data() {
    return {
      loading: false,
      course: {},
      leassons: [],
      continueWathing: [],
      extra: [],
    };
  },
  methods: {
    goToLesson(item) {
      this.$root.$emit("display-alert", {
        text: `A aula ${item.title} ficará disponível em breve`,
        type: 0,
        timeout: 1500,
      });
    },
    async goToCourse(item) {
      await this.$router.push({
        path: "/connect/aluno/curso/" + item.id,
        params: item.id,
      });
    },
  },
};
</script>

<style scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}
</style>
